import { Component, OnInit } from '@angular/core';
import {BaseView} from '../../../../../core/view/base.view';
import {
  WorkflowTaskFindOneByIdService
} from '../../../../../workflow/task/impl/service/workflowTaskFindOneById.service';
import {WorkflowTaskModel} from '../../../../../workflow/task/api/model/common/workflowTask.model';
import {IDialogComponent} from '../../../../../common/dialog/iDialog.component';
import {DialogWithInput} from '../../../../../common/dialog/dialogWithInput';
import {AuthService} from "../../../../../auth/api/service/auth.service";
export interface EmailSentViewInput {
  id: number;
}

@Component({
  selector: 'app-email-sent-view',
  templateUrl: './email-sent-view.component.html',
  providers: [
    WorkflowTaskFindOneByIdService,
  ]
})
export class EmailSentViewComponent extends BaseView implements IDialogComponent<EmailSentViewInput, void>, OnInit {
  dialog: DialogWithInput<EmailSentViewInput, void>;

  documentIds: number[] = [];
  entity: WorkflowTaskModel;
  payload: any;
  constructor(public workflowTaskFindOneByIdService: WorkflowTaskFindOneByIdService,
              public authService: AuthService) {
    super();
  }

  ngOnInit(): void {
  }

  entityLoaded(entity: WorkflowTaskModel) {
    this.entity = entity;
    this.payload = JSON.parse(this.entity.payload);
    this.documentIds = [];
    const documentIdsAttribute = this.entity.summary.publicAttributes.find(value => value.name === 'emailDocumentIds');
    if (documentIdsAttribute && documentIdsAttribute.value) {
      this.documentIds =documentIdsAttribute.value.split(',')
          .map(value => value.trim())
          .map(Number);
    }

  }

}
